import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { TimeSlotsComponent } from 'src/app/components/shared/time-slots/time-slots.component';
import { ApiResult } from 'src/app/models/PromiseResult';
import { ConsultationStatusModel, PackageStatusModel } from 'src/app/models/package';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DaterenderService } from 'src/app/services/daterender.service';
import { Consultation } from 'src/app/models/consultdoctors';
import { BreadcrumbService } from 'src/app/components/patient/shared/breadcrumb.service';
import { DateUtilService, moment_duration } from 'src/app/utilities/date.util.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SpecialityService } from 'src/app/services/speciality.service';
import { SupportService } from 'src/app/services/support.service';
import { Payment_Data, order_model } from 'src/app/models/basket';
import { CONSULTATION_TYPES, URLS } from 'src/app/constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
    selector: 'app-consult-doctor-support',
    templateUrl: './consult-doctor-support.component.html',
    styleUrls: ['./consult-doctor-support.component.css']
})
export class ConsultDoctorSupportComponent implements OnInit {

    @ViewChild(TimeSlotsComponent) time_slots_screen: TimeSlotsComponent;
    consultation: Consultation = new Consultation(3);
    slug: string = "";
    provider_id: string = "";
    is_uk_country: boolean = false;
    constructor(private readonly router: Router,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly utilitiesService: UtilitiesService,
        private readonly dateUtilService: DateUtilService,
        private readonly route: ActivatedRoute,
        private readonly specialtyService: SpecialityService,
        private readonly supportService: SupportService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly daterenderService: DaterenderService,
        private readonly providerstateService: ProviderStateService
    ) {


    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        (URLS.IS_UK)
        {
            this.is_uk_country = true;
        }
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/', this.slug, 'support'] },
            { label: 'Create Consultation' }
        ]);
        this.provider_id = this.providerstateService.getProviderId();
        this.consultation.other_data.supportConsult.verifyApi.patient_guid = this.route.snapshot.paramMap.get('patientGuid');
        this.consultation.other_data.supportConsult.verifyApi.req_id = Number(this.route.snapshot.paramMap.get('reqId'));

        await this.verifyPatientRequest();
        if (this.consultation.other_data.supportConsult.otherData.is_verified) {
            await this.getSpecialty(this.consultation.other_data.supportConsult.verifyApi.patient_guid, undefined, this.provider_id);
            this.setDates();
            this.consultation.consultApiData.consultation_type_id = Number(this.route.snapshot.paramMap.get('consultation_type_id'));
            this.consultation.consultApiData.user_package_id = this.route.snapshot.paramMap.get('user_package_id');
            await this.onConsultationChange();
        }
    }
    RouterNavigation(path: string) {
        this.router.navigate([path]);
    }
    async submitConsultation(): Promise<void> {
        this.consultation.other_data.submit_consultation_api_result = new ApiResult(true);
        this.consultation.other_data.payment_data.payment_start_api_result = new ApiResult(true);
        // for normal consultation ui will handle slot bdoctor choose
        // only for preferred slot this slot doctor choose will set 
        this.consultation.setSlotDoctorChoose();
        this.consultation.other_data.payment_data = new Payment_Data();
        this.consultation.consultApiData.additional_offers =
            (this.consultation.other_data.selected_additional_offer != null)
                ? [this.consultation.other_data.selected_additional_offer]
                : [];
        await this.supportService
            .consultDoctor(this.consultation.consultApiData)
            .toPromise()
            .then(async (result) => {
                this.consultation.other_data.submit_consultation_api_result.PromiseResult = result;
                if (result.success) {
                    if (result.data.consultation_request_number == null) {
                        const order: order_model = result.data;
                        this.consultation.other_data.payment_data.payment_start_api_result.PromiseResult = result;
                        this.consultation.other_data.payment_data.order_data = order;
                        this.consultation.other_data.submit_consultation_api_result.PromiseResult.success == true


                        //  await this.start_payment();
                        //    this.consultation.other_data.tabview_Data.nextTab(CONSULTATION_FORMS_TABS.PAYMENT_FORMS);
                    }
                    else {
                        this.consultation.other_data.payment_data.paymentSuccessData.consultationData.consultation_request_number = result.data.consultation_request_number;
                        //this.consultation.other_data.tabview_Data.nextTab(CONSULTATION_FORMS_TABS.PAYMENT_SUCCESS);
                    }
                } else {

                }
                this.consultation.other_data.payment_data.payment_start_api_result.Posting = false;
                this.consultation.other_data.submit_consultation_api_result.Posting = false;
                await this.RouterNavigation("/" + this.slug + "/support/fetch-list");
            }).catch((error: HttpErrorResponse) => {
                this.consultation.other_data.submit_consultation_api_result.ServerError = error.error;
                this.consultation.other_data.submit_consultation_api_result.PromiseResult.success = false;
                this.consultation.other_data.submit_consultation_api_result.Posting = false;
                this.consultation.other_data.payment_data.payment_start_api_result.ServerError = error.error;
                this.consultation.other_data.payment_data.payment_start_api_result.PromiseResult.success = false;
                this.consultation.other_data.payment_data.payment_start_api_result.Posting = false;
            });
    }

    async verifyPatientRequest() {
        this.consultation.other_data.supportConsult.verifyApiResult = new ApiResult(true);
        await this.supportService
            .verifyPatientRequest(this.consultation.other_data.supportConsult.verifyApi)
            .toPromise()
            .then((result) => {

                this.consultation.other_data.supportConsult.verifyApiResult.PromiseResult = result;
                if (result.success) {
                    this.consultation.consultApiData.patient_guid = this.consultation.other_data.supportConsult.verifyApi.patient_guid;
                    this.consultation.other_data.supportConsult.otherData.vendor_name = result.data.egd_vendors.vendor_name;
                    this.consultation.other_data.supportConsult.otherData.patient_name = result.data.first_name + " " + result.data.last_name;
                    this.consultation.other_data.supportConsult.otherData.is_verified = true;
                }
                this.consultation.other_data.supportConsult.verifyApiResult.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.consultation.other_data.supportConsult.verifyApiResult.ServerError = error.error;
                this.consultation.other_data.supportConsult.verifyApiResult.PromiseResult.success = false;
                this.consultation.other_data.supportConsult.verifyApiResult.Posting = false;
            });
    }

    async onSlotsDateChanged(selected_date: Date) {
        this.consultation.other_data.slotsFetch.api_result = new ApiResult(true);
        this.consultation.resetPreferredSlot();
        this.consultation.other_data.slotsFetch.timeSlots.timeSlots_api_data = [];
        this.consultation.other_data.slotsFetch.timeSlots.timeSlots = [];
        this.consultation.other_data.slotsFetch.api_data.slot_date = this.daterenderService.render_data(selected_date);
        this.consultation.other_data.slotsFetch.api_data.primary_speciality_id = this.consultation.other_data.selectedSpecialtyId;
        await this.supportService.getSlotsForConsultation(this.consultation.other_data.slotsFetch.api_data)
            .toPromise().then((result) => {
                this.consultation.other_data.slotsFetch.api_result.PromiseResult = result;
                if (result.success) {
                    this.consultation.other_data.slotsFetch.timeSlots.timeSlots_api_data = result.data
                }
                this.changeDetector.detectChanges();
                this.time_slots_screen.slotsDataGenerate();
                this.consultation.other_data.slotsFetch.api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.consultation.other_data.slotsFetch.api_result.ServerError = error.error;
                this.consultation.other_data.slotsFetch.api_result.PromiseResult.success = false;
                this.consultation.other_data.slotsFetch.api_result.Posting = false;
            });
    }

    onSlotSelected(slot_id: number) {
        this.consultation.consultApiData.preferred_slot_id = slot_id;
    }

    isPay(): boolean {
        return this.consultation.other_data.is_pay;
    }

    isPackageSpecialty(): boolean {
        return this.consultation.other_data.packageConsultDoctor.otherData.specialtyHide;
    }

    isConsultationSelected(): boolean {
        return this.consultation.consultApiData.consultation_type_id != null;
    }

    async onPaymentChange() {
        this.consultation.resetPackageData();
        if (this.isPay()) {
            this.consultation.reset_user_package_id();
        }
        else {
            //note this assumes that we only have one package at a time
            this.consultation.consultApiData.user_package_id = this.consultation.other_data.packages_status_data[0].id;
            this.setPackageOtherData(this.consultation.other_data.packages_status_data[0]);
        }
        await this.getPriorityList();
    }

    async onSpecialityChange() {
        switch (this.consultation.consultApiData.consultation_type_id) {
            case this.consultation.const_data.CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION:
                this.consultation.consultApiData.specialty_id = [this.consultation.other_data.selectedSpecialtyId];
                await this.getPriorityList();
                break;
            case this.consultation.const_data.CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION:
                this.consultation.consultApiData.specialty_id = [this.consultation.other_data.selectedSpecialtyId];
                await this.getPriorityList();
                break;
            default:
                break;
        }
    }

    async getSpecialty(patient_guid: string, common_health_id?: number, provider_id?: string) {
        this.consultation.other_data.specialty_list_api_result = new ApiResult(true);
        await this.specialtyService
            .GetAllSupportedPatient(patient_guid, common_health_id, provider_id)
            .toPromise()
            .then(async (result) => {
                this.consultation.other_data.specialty_list_api_result.PromiseResult = result;
                // const sp: SupportedSpecialty[] = result.data
                if (result.success) {
                    this.consultation.other_data.specialty_data = this.utilitiesService.getSelectItemList(result.data, "specialty_name", "id", false);
                    if (this.consultation.other_data.specialty_data.length == 1) {
                        this.consultation.other_data.selectedSpecialtyId = this.consultation.other_data.specialty_data[0].value;
                        await this.onSpecialityChange();
                    }
                }
                this.consultation.other_data.specialty_list_api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.consultation.other_data.specialty_list_api_result.ServerError = error.error;
                this.consultation.other_data.specialty_list_api_result.PromiseResult.success = false;
                this.consultation.other_data.specialty_list_api_result.Posting = false;
            });
    }

    renderAmount(amount: number | string, currency_type: string) {
        return this.utilitiesService.getRenderedAmount(Number(amount), currency_type);
    }


    setDates() {
        this.consultation.other_data.minDays = this.dateUtilService.addQuantity(new Date(), 1, moment_duration.days);
        this.consultation.other_data.minDays = this.dateUtilService.getDateResettingTime(this.consultation.other_data.minDays);
        this.consultation.other_data.maxDays = this.dateUtilService.addQuantity(new Date(), 21, moment_duration.days);
        this.consultation.other_data.maxDays = this.dateUtilService.getDateResettingTime(this.consultation.other_data.maxDays);
    }

    ResetSlots() {
        this.consultation.clear_slots();
        this.setDates();
    }

    async getPriorityList(): Promise<void> {
        this.consultation.resetPriorityID();
        if (
            this.consultation.consultApiData.patient_guid &&
            this.consultation.consultApiData.consultation_type_id > 0
        ) {
            this.consultation.other_data.priority_list_api_result = new ApiResult(true);
            this.consultation.resetPriorityList();
            await this.supportService
                .getPriorityByGuid(
                    this.consultation.consultApiData.patient_guid,
                    this.consultation.consultApiData.consultation_type_id,
                    this.consultation.other_data.selectedSpecialtyId
                )
                .toPromise()
                .then(async result => {
                    this.consultation.other_data.priority_list_api_result.PromiseResult = result;
                    if (result.success) {
                        this.consultation.other_data.priority_list = result.data.priority;
                        this.consultation.other_data.offers = result.data.additional_offers;
                        this.consultation.other_data.priority_list.forEach((ele) => {
                            ele.price_label = ele.p_priority_doctor_origin.country.country_name + '( ' + this.renderAmount(ele.amount, ele.country.currency_type) + ' )';
                            ele.no_price_label = ele.p_priority_doctor_origin.country.country_name;
                        });
                        if (this.consultation.other_data.packageConsultDoctor.otherData.priorityDisabled)
                            this.consultation.consultApiData.priority_type_id = this.consultation.other_data.packageConsultDoctor.otherData.priority_type_id;
                        else
                            this.consultation.consultApiData.priority_type_id = this.consultation.other_data.priority_list[0].id;
                        this.ResetSlots();
                    }
                    this.consultation.other_data.priority_list_api_result.Posting = false;
                }).catch((error: HttpErrorResponse) => {
                    this.consultation.other_data.priority_list_api_result.ServerError = error.error;
                    this.consultation.other_data.priority_list_api_result.PromiseResult.success = false;
                    this.consultation.other_data.priority_list_api_result.Posting = false;
                });
        }
    }

    setPackageOtherData(data: PackageStatusModel) {
        const data_upc: ConsultationStatusModel = data.user_package_count[0];
        if (data_upc.consultation_type_id > 0) {
            this.consultation.other_data.packageConsultDoctor.otherData.consultationDisabled = true;
            this.consultation.consultApiData.consultation_type_id = data_upc.consultation_type_id;
        }

        if (data_upc.specialty_id != null) {
            this.consultation.other_data.packageConsultDoctor.otherData.specialtyHide = true;
            this.consultation.other_data.packageConsultDoctor.otherData.specialty_name = data_upc.d_specialty_type.specialty_name;
            this.consultation.other_data.selectedSpecialtyId = data_upc.specialty_id;
            this.consultation.consultApiData.specialty_id = [data_upc.specialty_id];
        }

        if (data_upc.priority_type_id != null) {
            this.consultation.other_data.packageConsultDoctor.otherData.priorityDisabled = true;
            this.consultation.other_data.packageConsultDoctor.otherData.priority_type_id = data_upc.priority_type_id;
        }

        this.consultation.other_data.slotsFetch.api_data.vendor_guid = data.package_type.vendor_guid;
        this.consultation.other_data.slotsFetch.other_data.is_display = (data.package_type.vendor_guid != null);
        this.consultation.other_data.packageConsultDoctor.otherData.packagesDiabled = (data.package_type.vendor_guid != null)

        if (this.consultation.other_data.slotsFetch.other_data.is_display) {
            this.consultation.consultApiData.slot_doctor_choose = false;
        }

    }

    async onDataChange() {
        // need to reset values so adding the common consultaion and member changes function 
        this.consultation.resetSpecialties();
        this.consultation.resetSelectedDietPlan();
        this.consultation.resetFollowUpConultationID();
        // this.consultation.consultApiData.is_followup = this.consultation.consultApiData.consultation_type_id === this.consultation.const_data.CONSULTATION_TYPES.FOLLOW_UP_CONSULTATION;
        // if (this.isFollowUp()) {
        //     await this.getFollowUpConsultations();
        // }
        // else {
        this.consultation.consultApiData.followup_consultation_id = 1;
        // }
        await this.getPackages();
        await this.getPriorityList();
        await this.getSpecialty(this.consultation.consultApiData.patient_guid, undefined, this.provider_id);
    }


    async getPackages() {
        this.consultation.reset_pay_data();
        this.consultation.reset_package_status_data();
        this.consultation.reset_user_package_id();
        this.consultation.resetPackageData();
        if (this.consultation.consultApiData.consultation_type_id != null && this.consultation.consultApiData.patient_guid != null) {
            this.consultation.other_data.user_packages_list_api_result = new ApiResult(true);
            this.consultation.other_data.packageConsultDoctor.apiData = {
                patient_guid: this.consultation.consultApiData.patient_guid,
                consultation_type_id: this.consultation.consultApiData.consultation_type_id
            }

            await this.supportService
                .findPackages(this.consultation.other_data.packageConsultDoctor.apiData)
                .toPromise()
                .then((result) => {
                    this.consultation.other_data.user_packages_list_api_result.PromiseResult = result;
                    if (result.success) {
                        this.consultation.other_data.packages_status_data = result.data.packages;
                        if (this.consultation.other_data.packages_status_data.length > 0) {
                            this.consultation.other_data.is_pay = false;
                            this.consultation.other_data.packages_status_data.forEach((ele, index) => {
                                let final_name: string = ele.package_type.package_name + " (" + ele.nickname + ") ";
                                final_name = final_name.split("(N/A)")[0];
                                ele.final_name = final_name
                            });
                            this.consultation.consultApiData.user_package_id = this.consultation.other_data.packages_status_data[0].id;
                            this.setPackageOtherData(this.consultation.other_data.packages_status_data[0]);
                        }
                    }
                    this.consultation.other_data.user_packages_list_api_result.Posting = false;
                }).catch((error: HttpErrorResponse) => {
                    this.consultation.other_data.user_packages_list_api_result.ServerError = error.error;
                    this.consultation.other_data.user_packages_list_api_result.PromiseResult.success = false;
                    this.consultation.other_data.user_packages_list_api_result.Posting = false;
                });
        }
    }

    async onConsultationChange() {
        await this.onDataChange();
    }

    dirty() {
        this.consultation.other_data.component_leave.sc = true;
    }

    notDirty() {
        this.consultation.other_data.component_leave.sc = false;
        this.consultation.other_data.component_leave.Fu = false;
    }

    isPosting(): boolean {
        return this.consultation.other_data.form_api_result.Posting ||
            this.consultation.other_data.user_packages_list_api_result.Posting ||
            this.consultation.other_data.nutritionHealthCons.plans.api_result.Posting ||
            // this.consultation.other_data.packages_form_api_result.Posting ||
            this.consultation.other_data.members_list_api_result.Posting ||
            this.consultation.other_data.specialty_list_api_result.Posting ||
            this.consultation.other_data.priority_list_api_result.Posting ||
            this.consultation.other_data.discount_list_api_result.Posting ||
            this.consultation.other_data.discount_code_apply_api_result.Posting ||
            this.consultation.other_data.submit_consultation_api_result.Posting ||
            this.consultation.other_data.diet_preference_list_api_result.Posting ||
            this.consultation.other_data.dietition_list_api_result.Posting ||
            this.consultation.other_data.payment_data.transaction_submit_api_result.Posting ||
            this.consultation.other_data.payment_data.payment_start_api_result.Posting ||
            this.consultation.other_data.closed_consultation_list_api_result.Posting;
    }


    text(data: ConsultationStatusModel[]) {
        let text = [];
        data.forEach(ele => {
            text.push(ele.current_count + " consultation left");
        });
        return text.toString();
    }

}
